class ProductIntegration extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.product = this.closest('.product');
    if (!this.product) return;

    this.dataset.ready = 'true';
    this.composeProductControls();
    this.replaceEmptyHulkOfferBadges(this.product);
    this.normalizeVariantAlternativesHeadings(this.product);

    this.observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          this.replaceEmptyHulkOfferBadges(node);
          this.normalizeVariantAlternativesHeadings(node);
        }, this);
      }, this);
    }.bind(this));

    this.observer.observe(this.product, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    delete this.dataset.ready;
  }

  composeProductControls() {
    if (this.product.querySelector('.custom-wrapper')) return;

    var elementsToWrap = this.product.querySelectorAll(
      'variant-selects, .shopify-block, .shopify-app-block, .order-time, .ctm-btn, .product--description',
    );
    if (elementsToWrap.length === 0) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'custom-wrapper';
    elementsToWrap[0].parentNode.insertBefore(wrapper, elementsToWrap[0]);
    elementsToWrap.forEach(function (element) {
      wrapper.appendChild(element);
    });
  }

  replaceEmptyHulkOfferBadges(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 11)) return;

    var selector = 'a.offer-badge:not([href])';
    var anchors = [];
    if (root.nodeType === 1 && root.matches(selector)) anchors.push(root);
    anchors = anchors.concat(Array.from(root.querySelectorAll(selector)));

    anchors.forEach(function (anchor) {
      var badgeText = anchor.textContent.trim();
      var isEmptyBadge = badgeText === '' && anchor.children.length === 0;
      var isHiddenUndefinedBadge =
        badgeText === 'undefined' && anchor.children.length === 0 && anchor.style.display === 'none';
      if (!isEmptyBadge && !isHiddenUndefinedBadge) return;

      var badge = document.createElement('span');
      Array.from(anchor.attributes).forEach(function (attribute) {
        badge.setAttribute(attribute.name, attribute.value);
      });
      anchor.replaceWith(badge);
    });
  }

  normalizeVariantAlternativesHeadings(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 11)) return;

    [
      ['h3.variant-alternatives__heading', 'h2'],
      ['h4.variant-alternatives__group-heading', 'h2'],
      ['h5.variant-alternatives__title', 'h3'],
    ].forEach(function (headingRule) {
      var selector = headingRule[0];
      var replacementTag = headingRule[1];
      var headings = [];
      if (root.nodeType === 1 && root.matches(selector)) headings.push(root);
      headings = headings.concat(Array.from(root.querySelectorAll(selector)));

      headings.forEach(function (heading) {
        var replacement = document.createElement(replacementTag);
        Array.from(heading.attributes).forEach(function (attribute) {
          replacement.setAttribute(attribute.name, attribute.value);
        });
        replacement.append.apply(replacement, Array.from(heading.childNodes));
        heading.replaceWith(replacement);
      });
    });
  }
}

if (!customElements.get('product-integration')) {
  customElements.define('product-integration', ProductIntegration);
}
